import { Button, Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import tryDemoBg from "../../Images/ZeitonTryDemoUpperBg.png";

interface TryDemoProps {
    isButtonDisabled: boolean,
    onTryDemoClickFunction: () => void
}

function ZeitonTryDemoComponent(props: TryDemoProps) {
    const { t } = useTranslation();

    return (
        <div className="px-[25px] xl:px-[100px] relative w-full flex justify-center bg-#F6F6F6">
            <img src={tryDemoBg} alt="TryDemoUpperBg" className="object-cover h-full min-h-[130px] w-full rounded-tr-[22px] rounded-tl-[22px]" />
            <div className="absolute inset-0 flex flex-col xl:flex-row justify-center items-center gap-4 px-[30px]">
                <div className="flex justify-center items-center gap-2">
                    <Typography className="uppercase text-#282828 font-bold text-[20px] xl:text-[22px] 2xl:text-[26px] leading-[16px] xl:leading-[20px] 2xl:leading-[24px]">
                        ZEITON
                    </Typography>
                </div>
                <hr className="bg-#282828 w-[1px] hidden xl:block xl:py-[30px]" />
                <Typography className="uppercase text-#282828 font-medium text-[10px] lg:text-[15px] 2xl:text-[20px] text-center md:text-[16px] xl:text-[20px] leading-[12px] xl:leading-[16px] 2xl:leading-[18px] xl:max-w-[450px] 2xl:max-w-none">
                    {t("TheUltimateTimeManagementSolution")}
                </Typography>
                <Button id="tryDemoBtn" onClick={props.onTryDemoClickFunction} disabled={props.isButtonDisabled} className="uppercase bg-#333333 hover:bg-#4E4E4E rounded-[25px] h-[40px] px-[50px] text-sm font-bold shadow-none hover:shadow-none flex justify-center items-center">
                    {t("TryDemo")}
                </Button>
            </div>
        </div>
    );
}

export default ZeitonTryDemoComponent;
